import { render } from "./country-list.vue?vue&type=template&id=036ac644&ts=true"
import script from "./country-list.ts?vue&type=script&lang=ts&external"
export * from "./country-list.ts?vue&type=script&lang=ts&external"

import "./country-list.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__